'use client';

import type { ReactNode } from 'react';
import { SidebarNavigationSimple } from '@/components/application/app-navigation/sidebar-navigation/sidebar-simple';
import { cx } from '@/utils/cx';
import { useLayoutNav } from '@/components/layouts/use-layout-nav';

interface AppLayoutExpandedProps {
    activeUrl: string;
    children: ReactNode;
    className?: string;
}

export function AppLayoutExpanded({ activeUrl, children, className }: AppLayoutExpandedProps) {
    const { items, footerItems } = useLayoutNav();

    return (
        <div className={cx('flex flex-col bg-primary lg:flex-row', className)}>
            <SidebarNavigationSimple
                activeUrl={activeUrl}
                items={items}
                footerItems={footerItems}
            />
            <main className="flex min-w-0 flex-1 flex-col">
                {children}
            </main>
        </div>
    );
}
